export function getForm(wfConfig, formId) {
    var _a;
    return (_a = wfConfig.formsById) === null || _a === void 0 ? void 0 : _a[formId];
}
//# sourceMappingURL=controller-props.js.map